import ProjectMembersPermissionsConfigContent from './ProjectMembersPermissionsConfigContent'

export default ProjectMembersPermissionsConfigContent
